import React from 'react';
import { Switch, Route } from 'react-router';
import Box from '@material-ui/core/Box';
import { PublicScreenWrapper } from '../../screens/public-screens/PublicScreenWrapper';
import { useCampfireTheme } from '../../theme/useCampfireTheme';
import { PublicAppBar } from '../public-shell/public-app-bar/PublicAppBar';
import { TrialWelcomeScreen } from '../../screens/trial-screens/TrailWelcomeScreen';
import { TrialFindOrgScreen } from '../../screens/trial-screens/find-org/TrialFindYourOrgScreen';
import { CreateTrialAccountForm } from '../../screens/trial-screens/create-trial-account/CreateTrialAccountForm';

export const TRIAL_SCREEN_SHRINK_WIDTH = 940;

export const TrialShell = () => {
  const { isSm } = useCampfireTheme();

  return (
    <>
      <PublicAppBar logoOnly />
      <Box
        height={window.innerHeight}
        className='Page'
        display='flex'
        flex='1 1 auto'
        flexDirection='column'
        borderRadius={4}
        position='relative'
        style={{
          overflowX: 'visible',
          overflowY: 'auto',
          backgroundColor: '#f6f8f9',
        }}
      >
        <Switch>
          <Route
            exact
            path='/'
            render={() => (
              <PublicScreenWrapper floating shrink={isSm ? false : TRIAL_SCREEN_SHRINK_WIDTH}>
                <TrialWelcomeScreen />
              </PublicScreenWrapper>
            )}
          />
          <Route
            exact
            path='/create-trial'
            render={() => (
              <PublicScreenWrapper floating shrink={isSm ? false : TRIAL_SCREEN_SHRINK_WIDTH}>
                <CreateTrialAccountForm />
              </PublicScreenWrapper>
            )}
          />
          <Route
            exact
            path='/find-org'
            render={() => (
              <PublicScreenWrapper floating shrink={isSm ? false : TRIAL_SCREEN_SHRINK_WIDTH}>
                <TrialFindOrgScreen />
              </PublicScreenWrapper>
            )}
          />
        </Switch>
      </Box>
    </>
  );
};
